import { IonSpinner, IonInput, IonTextarea, IonTitle, IonGrid, IonBackButton, IonButtons, IonToast, IonActionSheet, IonModal, IonRouterLink, IonList, IonContent, IonPopover, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { createOutline, closeOutline, rocketOutline, helpCircle, shareSocialOutline, eye, close, heartCircle, trashOutline, listOutline, eyeOffOutline, eyeOutline, banOutline, alertCircleOutline, arrowRedoOutline, ellipsisVertical, heart, earth, people } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { useState, useRef }  from 'react';
import { Dialog, ConfirmResult } from '@capacitor/dialog';
import { Share } from '@capacitor/share';

import NServer, { UIElement, handleRouteError } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const UserBar : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view }) => {
    
    const [menu, openMenu] = useState(false);
    const [showShareMsg, setShowShareMsg] = useState(false);
    const [sponsorHelp, showSponsorHelp] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editTitle, setEditTitle] = useState("");
    const [editDesc, setEditDesc] = useState("");
    const [editPostLoading, setEditPostLoading] = useState(false);
    const router = useIonRouter();

    const openPopover = (e: any) => {
        openMenu(true);
    };

    // click on user
    const onUser = () => {
        router.push("/user/" + content.user, "forward", "push");
    }

    // report the post
    const reportPost = () => {
        openMenu(false);
        router.push("/report/" + content.id + "/content", "forward", "push");
    }

    // share the post
    const sharePost = async () => {
        let link = "https://nwallet.me/d/social.php?r=cc" + content.id;

        await Share.share({
            title: "",
            text: "",
            url: link,
            dialogTitle: "Share Post"
        });

        openMenu(false);
    }

    // block the user
    const blockUser = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_BLOCK_CHAT_TITLE), GetStr(LANGUAGE.TXT_BLOCK_CHAT_DESC));
        if (accept.value)
        {
            doBlockUser();
        }
    }

    // follow the user
    const followUser = async (followed: string) => {
        openMenu(false);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            user: content.user,
            followed: followed
        }

        var server = new NServer();
        await server.sendForm("nc_follow", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            // refresh the window
            await onUpdate(index, content);
        }
    }

    // block the user
    const doBlockUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: content.user,
            type : "user"
        }

		var server = new NServer();
        await server.sendForm("block", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/blocklist", "back", "pop");
        }
    }

    // delete the post
    const deletePost = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_ASK_DEL_POST_CAP), GetStr(LANGUAGE.TXT_ASK_DEL_POST_DESC));
        if (accept.value)
        {
            doDeletePost();
        }
    }

    // do the post deletion
    const doDeletePost = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id
        }

		var server = new NServer();
        await server.sendForm("nc_delete_content", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            window.location.reload();
        }
    }

    // share to chat
    const shareChat = async () =>
    {
        openMenu(false);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id
        }

		var server = new NServer();
        await server.sendForm("nc_share_to_chat", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // show success
            setShowShareMsg(true);
        }
    }

    // close the video
    const closeVideo = () => {
        
    }

    // boost the post
    const boostPost = () => {
        router.push("/boost/" + content.id, "forward", "push");
    }

    // load the post and edit it
    const editCurPost = async () => {
        setEditPostLoading(true);
        setShowEdit(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id
        }

        var server = new NServer();
        await server.getList("nc_content_detail", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setEditTitle(server.data.content.title);
            setEditDesc(server.data.content.desc);

            setEditPostLoading(false);
        }
    }

    // edit the post
    const doEditPost = async () => {
        setEditPostLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            title: editTitle,
            desc: editDesc
        }

        var server = new NServer();
        await server.sendForm("nc_edit_content", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);

            setEditPostLoading(false);
        }
        else
        {
            setEditPostLoading(false);
            setShowEdit(false);
        }
    }

    return (
        <div className={ view=="video" ? "fullscreen-bar-wrapper" : "" }>
        {
            /* sponsor bar */
            content.sponsored && view == "def" ?
        <div className="sponsorbar">
            { GetStr(LANGUAGE.TXT_SPONSOR_POST) }
            <IonIcon className="sponsor-but" icon={ helpCircle } onClick={ ()=> showSponsorHelp(true) } />
        </div>
            :
        <div/>
        }
        { /* user bar */ }
        <IonItem id="nc-content" className={ view=="video" ? "fullscreen-bar" : "" } lines="none">
            <IonAvatar className="ub-avt" slot="start" onClick={onUser}>
                <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonLabel className="ion-text-wrap">
                <h2>
                    <IonRouterLink color="dark" onClick={onUser}>
                        <IonText className={ view =="video" ? "text-white" : "" }><b>{ content.user_name }</b></IonText>
                        &nbsp;&nbsp;<img className={ content.user_bm == 1 ? "bluemark" : "ion-hide" } src="/assets/img/bm.png" /></IonRouterLink>
                    {
                        content.relationship < 0 ?
                    <IonText>&nbsp;-&nbsp;<IonRouterLink onClick={ ()=> followUser("yes") }><b>Follow</b></IonRouterLink></IonText>
                        :
                    <div/>
                    }
                </h2>
                <div className="visibility-bar">
                    <IonNote>{content.time}&nbsp;&nbsp;
                    <IonIcon icon={ content.visibility == "Public" ? earth : (content.visibility == "Private" ? people : 
                        (content.visibility == "Super-Like" ? heartCircle : heart )) } />
                    &nbsp;&nbsp;{content.visibility}</IonNote>
                </div>
            </IonLabel>
            {
                // close buttons
                view == "video" ?
            <IonButtons slot="end">
                <IonBackButton className="white-shadow" text="" defaultHref="/main" icon={close}></IonBackButton>
            </IonButtons>
                :
            <IonButton slot="end" fill="clear" onClick={openPopover}>
                <IonIcon icon={ellipsisVertical} color="dark"/>
            </IonButton>
            }

            { /* menu */ }
            <IonActionSheet
                isOpen={menu}
                onDidDismiss={() => openMenu(false)}
                buttons={
                    content.relationship == 5 ?     /* own content */
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_BOOST_POST),
                        icon: rocketOutline,
                        handler: boostPost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_CHAT),
                        icon: arrowRedoOutline,
                        handler: shareChat
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_POST),
                        icon: shareSocialOutline,
                        handler: sharePost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_EDIT_POST),
                        icon: createOutline,
                        handler: editCurPost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_DELETE_POST),
                        icon: trashOutline,
                        handler: deletePost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } ]
                    :
                    content.relationship >= 0 ?
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_CHAT),
                        icon: arrowRedoOutline,
                        handler: shareChat
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_POST),
                        icon: shareSocialOutline,
                        handler: sharePost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_USER_UNFOLLOW),
                        icon: eyeOffOutline,
                        handler: () => { followUser("no") }
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_REPORT_ADMIN),
                        icon: alertCircleOutline,
                        handler: reportPost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_BLOCK_USER),
                        icon: banOutline,
                        handler: blockUser
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } ]
                    :
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_CHAT),
                        icon: arrowRedoOutline,
                        handler: shareChat
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_SHARE_POST),
                        icon: shareSocialOutline,
                        handler: sharePost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_USER_FOLLOW),
                        icon: eyeOutline,
                        handler: () => { followUser("yes") }
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_REPORT_ADMIN),
                        icon: alertCircleOutline,
                        handler: reportPost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_BLOCK_USER),
                        icon: banOutline,
                        handler: blockUser
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } ]
                }
                
                >
            </IonActionSheet>

            <IonToast
                isOpen={showShareMsg}
                onDidDismiss={() => setShowShareMsg(false)}
                message={ GetStr(LANGUAGE.TXT_SHARE_CHAT_SUCCESS) }
                position="bottom"
                duration={4000}
                buttons={[
                  {
                    text: 'X',
                    role: 'cancel',
                    handler: () => {
                        setShowShareMsg(false);
                    }
                  }
                ]}
              />
        </IonItem>

        { /* sponsored post explaination */ }
        <IonModal
            isOpen={sponsorHelp}
            initialBreakpoint={ 0.8 }
            onDidDismiss={() => showSponsorHelp(false)}>
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_SPONSOR_HELP_CAP) }</h5></IonTitle>
                </IonToolbar>
                <IonContent>
                    <IonGrid className="ion-no-padding">
                        <IonRow>
                            <IonCol>
                            </IonCol>
                            <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                                <div><IonImg className="info-pic" src="/assets/img/sponsored_pic.png" /></div>
                                <div><IonText>{ GetStr(LANGUAGE.TXT_SPONSOR_HELP_DESC) }</IonText></div>
                                <div>
                                    <IonButton className="main-but ion-margin-top" expand="block" onClick={()=> showSponsorHelp(false)}>
                                        { GetStr(LANGUAGE.TXT_SPONSOR_HELP_CLOSE) }
                                    </IonButton>
                                </div>
                            </IonCol>
                            <IonCol>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonContent>
            </div>
        </IonModal>

        { /* edit post UI */ }
        <IonModal
            isOpen={showEdit}
            initialBreakpoint={ 0.85 }
            onDidDismiss={() => setShowEdit(false)}>
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_EDIT_POST_CAP) }</h5></IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={()=>{setShowEdit(false)}}>
                            <IonIcon icon={closeOutline} size="large"/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent>
                    <IonGrid className="ion-no-padding main-content">
                        <IonRow>
                            {
                                editPostLoading ?
                            <IonCol className="spinnerCenter col-empty-content">
                                <IonSpinner name="crescent" />
                            </IonCol>
                                :
                            <IonCol>
                                <IonItem className="ion-margin-top">
                                    <IonInput placeholder={ GetStr(LANGUAGE.TXT_EDIT_POST_TITLE) } value={ editTitle } 
                                        onIonChange={ (e) => setEditTitle(e.detail.value!) }></IonInput>
                                </IonItem>
                                <IonItem className="ion-margin-top">
                                    <IonTextarea rows={12} placeholder={ GetStr(LANGUAGE.TXT_EDIT_POST_DESC) } value={ editDesc }
                                        onIonChange={ (e) => setEditDesc(e.detail.value!) }></IonTextarea>
                                </IonItem>
                                <div className="ion-margin-top ion-margin-start ion-margin-end" onClick={doEditPost}>
                                    <IonButton className="main-but" expand="block">
                                        { GetStr(LANGUAGE.TXT_EDIT_POST_DO) }
                                    </IonButton>
                                </div>
                                <div className="ion-margin-top ion-margin-start ion-margin-end">
                                    <IonButton className="main-but" color="secondary" expand="block" onClick={()=> setShowEdit(false) }>
                                        { GetStr(LANGUAGE.TXT_CANCEL) }
                                    </IonButton>
                                </div>
                            </IonCol>
                            }
                        </IonRow>
                    </IonGrid>
                </IonContent>
            </div>
        </IonModal>

        </div>
    );
};

export default UserBar;